<template>
  <div class="page-container">
    <!-- 统计卡片 -->
    <div class="stats-row">
      <div class="stat-card"><div class="stat-label">总申请数</div><div class="stat-value">{{ stats.total || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">待审核</div><div class="stat-value" style="color:#e6a23c;">{{ stats.pending || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">已通过</div><div class="stat-value" style="color:#67c23a;">{{ stats.passed || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">已拒绝</div><div class="stat-value" style="color:#f56c6c;">{{ stats.rejected || 0 }}</div></div>
      <div class="stat-card"><div class="stat-label">申请失败</div><div class="stat-value" style="color:#909399;">{{ stats.failed || 0 }}</div></div>
    </div>

    <!-- 搜索 -->
    <div class="filter-bar">
      <el-form :inline="true" :model="search" size="small">
        <el-form-item label="申请编号"><el-input v-model="search.pnoNo" placeholder="请输入申请编号" clearable style="width:160px;"></el-input></el-form-item></el-form-item>
        <el-form-item label="用户ID"><el-input v-model="search.customerNo" placeholder="请输入用户ID" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="姓名"><el-input v-model="search.name" placeholder="请输入姓名" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="手机号"><el-input v-model="search.phone" placeholder="请输入手机号" clearable style="width:130px;"></el-input></el-form-item>
        <el-form-item label="邮箱"><el-input v-model="search.email" placeholder="请输入邮箱" clearable style="width:160px;"></el-input></el-form-item>
        <el-form-item label="推荐人"><el-input v-model="search.referrer" placeholder="请输入推荐人" clearable style="width:120px;"></el-input></el-form-item>
        <el-form-item label="国家">
          <el-select v-model="search.countryCode" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="c in countries" :key="c.countryCode" :label="c.countryCode + ' ' + (c.countryCname||c.countryName)" :value="c.countryCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册方式">
          <el-select v-model="search.regWay" placeholder="全部" clearable style="width:100px;">
            <el-option label="H5" :value="1"></el-option><el-option label="Android" :value="2"></el-option>
            <el-option label="IOS" :value="3"></el-option><el-option label="PC" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户组">
          <el-select v-model="search.groupId" placeholder="全部" clearable style="width:140px;">
            <el-option v-for="g in groupOptions" :key="g.id" :label="g.groupName" :value="g.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户标签">
          <el-select v-model="search.tagId" placeholder="全部" clearable style="width:120px;">
            <el-option v-for="t in tagOptions" :key="t.id" :label="t.tagName" :value="t.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="search.createDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;"></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">搜索</el-button><el-button @click="resetSearch">重置</el-button></el-form-item>
      </el-form>
    </div>

    <div class="table-wrapper">
      <div class="table-header" style="display:flex;align-items:center;justify-content:space-between;">
        <span class="table-title">开户申请列表</span>
        <div class="table-actions">
          <el-button v-auth="'business:accountApply:review'" size="small" type="primary" icon="el-icon-check" :disabled="selection.length === 0" @click="batchApprove">审批</el-button>
          <el-button v-auth="'business:accountApply:review'" size="small" type="danger" icon="el-icon-close" :disabled="selection.length === 0" @click="batchReject">拒绝</el-button>
          <el-button v-auth="'business:accountApply:export'" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
        </div>
      </div>
      <el-tabs v-model="activeTab" @tab-click="fetchList">
        <el-tab-pane :label="'全部(' + (stats.total || 0) + ')'" name="all"></el-tab-pane>
        <el-tab-pane :label="'待审核(' + (stats.pending || 0) + ')'" name="pending"></el-tab-pane>
        <el-tab-pane :label="'已通过(' + (stats.passed || 0) + ')'" name="passed"></el-tab-pane>
        <el-tab-pane :label="'已拒绝(' + (stats.rejected || 0) + ')'" name="rejected"></el-tab-pane>
        <el-tab-pane :label="'申请失败(' + (stats.failed || 0) + ')'" name="failed"></el-tab-pane>
      </el-tabs>
      <el-table ref="applyTable" :data="tableData" border v-loading="loading" style="width:100%;" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="pnoNo" label="申请编号" width="110"></el-table-column>
        <el-table-column prop="customerNo" label="用户ID" width="120"></el-table-column>
        <el-table-column prop="name" label="姓名" width="90"></el-table-column>
        <el-table-column prop="referrer" label="推荐人" width="90"></el-table-column>
        <el-table-column label="手机号" width="150"><template slot-scope="{row}">{{ (row.phonePrefix ? '+' + row.phonePrefix + ' ' : '') + (row.phoneNumber || '') }}</template></el-table-column>
        <el-table-column prop="email" label="邮箱" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="国家" width="80">
          <template slot-scope="scope">{{ countryLabel(scope.row.countryCode) }}</template>
        </el-table-column>
        <el-table-column label="注册方式" width="90">
          <template slot-scope="scope">{{ regLabel(scope.row.regWay) }}</template>
        </el-table-column>
        <el-table-column label="客户组" width="110">
          <template slot-scope="scope">{{ groupLabel(scope.row.groupId) }}</template>
        </el-table-column>
        <!-- 列宽要放得下一个 6 字标签胶囊 + 「…」（实测「KYC已拒绝」胶囊约 89px），
             和 clientAccount 的风险标签列保持同一套渲染 -->
        <el-table-column label="风险标签" width="140">
          <template slot-scope="scope">
            <!-- 只露第一个标签，多于一个时补「…」，鼠标悬浮用 tooltip 看全部标签。
                 标签名是后台自定义的，再宽的列也可能被撑爆，所以只有一个标签时也保留 tooltip
                 （tooltip 用 light 白底，彩色胶囊才看得清：胶囊底色是带透明度的） -->
            <el-tooltip
              v-if="riskTags(scope.row).length"
              placement="top"
              effect="light"
              popper-class="ctag-tip-popper"
            >
              <div slot="content" class="ctag-tip">
                <span v-for="t in riskTags(scope.row)" :key="t.n" class="ctag" :style="tagPillStyle(t.c)"><span class="ctag-dot" :style="{background: t.c}"></span>{{ t.n }}</span>
              </div>
              <span class="ctag-cell">
                <span class="ctag" :style="tagPillStyle(riskTags(scope.row)[0].c)"><span class="ctag-dot" :style="{background: riskTags(scope.row)[0].c}"></span>{{ riskTags(scope.row)[0].n }}</span>
                <span v-if="riskTags(scope.row).length > 1" class="ctag-more">…</span>
              </span>
            </el-tooltip>
            <span v-else style="color:#c0c4cc;">--</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="statusType(scope.row.approvedStatus)" size="mini">{{ statusLabel(scope.row.approvedStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="regTime" label="申请时间" width="160"></el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" width="160"></el-table-column>
        <el-table-column prop="reviewer" label="审核人" width="100"></el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button v-auth="'business:accountApply:review'" v-if="scope.row.approvedStatus === 1" type="text" size="small" style="color:var(--brand-primary);" @click="openReview(scope.row)">审核</el-button>
            <el-button v-else type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="(v)=>{pageSize=v;fetchList()}" @current-change="(v)=>{pageNum=v;fetchList()}"
        :current-page="pageNum" :page-sizes="[10,50,100]" :page-size="pageSize" layout="total,sizes,prev,pager,next,jumper" :total="total"></el-pagination>
    </div>

    <!-- 详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" width="900px" :close-on-click-modal="false">
      <div slot="title" style="display:flex;align-items:center;gap:12px;">
        <span>申请详情</span>
        <el-tag v-if="detail" :type="statusType(detail.approvedStatus)" size="small">{{ statusLabel(detail.approvedStatus) }}</el-tag>
      </div>
      <el-tabs v-if="detail">
        <el-tab-pane label="申请信息">
          <div class="detail-section">
            <div class="detail-sec-title">基础信息</div>
            <div class="info-grid">
              <div class="info-item"><span class="info-label">申请编号</span><span class="info-val">{{ detail.pnoNo }}</span></div>
              <div class="info-item"><span class="info-label">用户ID</span><span class="info-val">{{ detail.customerNo }}</span></div>
              <div class="info-item"><span class="info-label">姓名</span><span class="info-val">{{ detail.name }}</span></div>
              <div class="info-item"><span class="info-label">手机号</span><span class="info-val">{{ (detail.phonePrefix ? '+' + detail.phonePrefix + ' ' : '') + (detail.phoneNumber || '') }}</span></div>
              <div class="info-item"><span class="info-label">邮箱</span><span class="info-val">{{ detail.email || '-' }}</span></div>
              <div class="info-item"><span class="info-label">国家</span><span class="info-val">{{ countryLabel(detail.countryCode) }}</span></div>
              <div class="info-item"><span class="info-label">注册方式</span><span class="info-val">{{ regLabel(detail.regWay) }}</span></div>
              <div class="info-item"><span class="info-label">推荐人</span><span class="info-val">{{ detail.referrer || '-' }}</span></div>
              <div class="info-item"><span class="info-label">客户组</span><span class="info-val">{{ groupLabel(detail.groupId) }}</span></div>
              <div class="info-item"><span class="info-label">注册IP</span><span class="info-val">{{ detail.regIp || '-' }}</span></div>
              <div class="info-item"><span class="info-label">激活状态</span><span class="info-val">{{ detail.isActive === 2 ? '已激活' : '未激活' }}</span></div>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">证件信息</div>
            <div class="info-grid">
              <div class="info-item"><span class="info-label">证件类型</span><span class="info-val">{{ docTypeLabel(detail.docType) }}</span></div>
              <div class="info-item"><span class="info-label">证件号码</span><span class="info-val">{{ detail.docNumber || '---' }}</span></div>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">OCR与数据比对</div>
            <table style="width:100%;border-collapse:collapse;font-size:13px;border:1px solid #ebeef5;">
              <thead>
                <tr style="background:#f5f7fa;">
                  <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">字段</th>
                  <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">OCR提取</th>
                  <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">用户填写</th>
                  <th style="padding:8px 12px;text-align:left;font-weight:500;color:#909399;border:1px solid #ebeef5;">后端比对</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in ocrData" :key="r.field">
                  <td style="padding:8px 12px;border:1px solid #ebeef5;">{{ r.field }}</td>
                  <td style="padding:8px 12px;border:1px solid #ebeef5;color:#c0c4cc;">{{ r.ocr }}</td>
                  <td style="padding:8px 12px;border:1px solid #ebeef5;">{{ r.user }}</td>
                  <td style="padding:8px 12px;border:1px solid #ebeef5;">
                    <el-tag :type="r.match ? 'success' : 'danger'" size="mini">{{ r.match ? '一致' : '不一致' }}</el-tag>
                  </td>
                </tr>
              </tbody>
            </table>
            <div style="display:flex;gap:16px;margin-top:8px;font-size:12px;">
              <span style="color:#909399;">OCR状态: <el-tag :type="buildOcrRow(detail, 1).match ? 'success' : 'warning'" size="mini">{{ buildOcrRow(detail, 1).match ? '已识别' : '未识别' }}</el-tag></span>
              <span style="color:#909399;">是否需审核: <el-tag :type="detail.needReview ? 'primary' : 'info'" size="mini">{{ detail.needReview ? '是' : '否' }}</el-tag></span>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">风险与设备环境</div>
            <div class="risk-cards">
              <div v-if="detail.factorServiceName" class="risk-card"><span class="risk-icon">🪪</span><div><div class="risk-label">{{ detail.factorServiceName || '证件信息' }}</div><div class="risk-val"><el-tag type="success" size="mini">已识别</el-tag></div></div></div>
              <div v-if="detail.ocrServiceName" class="risk-card"><span class="risk-icon">🔍</span><div><div class="risk-label">{{ detail.ocrServiceName }}</div><div class="risk-val"><el-tag type="success" size="mini">已识别</el-tag></div></div></div>
              <div class="risk-card"><span class="risk-icon">🛡️</span><div><div class="risk-label">风控标签</div><div class="risk-val"><el-tag :type="detail.riskTags ? 'warning' : 'success'" size="mini">{{ detail.riskTags || '--' }}</el-tag></div></div></div>
            </div>
            <div style="font-size:13px;color:#606266;line-height:2;">
              <div><span style="color:#909399;">IP归属地:</span> {{ detail.ipRegion || '-' }}</div>
              <div><span style="color:#909399;">IP地址:</span> {{ detail.regIp || '-' }}</div>
              <div><span style="color:#909399;">手机归属地:</span> {{ detail.phoneRegion || '-' }}</div>
              <div><span style="color:#909399;">证件归属地:</span> {{ detail.idCardRegion || '-' }}</div>
              <div><span style="color:#909399;">设备指纹:</span> {{ detail.deviceFingerprint || '-' }}</div>
              <div>
                <span style="color:#909399;">设备黑名单:</span> <el-tag type="success" size="mini">正常</el-tag>
                <span style="margin-left:8px;color:#909399;">IP黑名单:</span> <el-tag type="success" size="mini">正常</el-tag>
              </div>
              <div><span style="color:#909399;">命中规则:</span> 无</div>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">审核记录</div>
            <div style="position:relative;padding-left:20px;border-left:2px solid #67c23a;">
              <div v-for="(log, i) in (detail.auditLogs || [])" :key="i" :style="{marginBottom: i<(detail.auditLogs||[]).length-1?'16px':'0', position:'relative'}">
                <div style="position:absolute;left:-25px;width:10px;height:10px;border-radius:50%;background:#67c23a;border:2px solid #fff;"></div>
                <div style="font-size:13px;font-weight:500;">{{ log.operator || '系统' }} <el-tag :type="log.action.includes('通过')?'success':log.action.includes('拒绝')?'danger':'primary'" size="mini">{{ log.action }}</el-tag></div>
                <div style="font-size:11px;color:#909399;margin-top:2px;">{{ log.operateTime }}</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer"><el-button @click="detailVisible=false">关闭</el-button></div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog :visible.sync="reviewVisible" width="1100px" :close-on-click-modal="false">
      <div slot="title">开户审核</div>
      <div v-if="reviewDetail" class="kyc-layout">
        <!-- 左侧：申请资料 -->
        <div class="kyc-docs">
          <div style="font-size:14px;font-weight:600;margin-bottom:8px;">申请资料</div>
          <!-- 证件图 URL 来自 /business/accountApply/detail（CustomerVo.frontImageUrl/backImageUrl/handheldImageUrl）；
               有图直接渲染缩略图（点击看原图），无图或加载失败回退占位图标 -->
          <div v-for="doc in kycDocs" :key="doc.key" class="kyc-doc-card" :class="{'is-filled': showDocImg(doc)}"
               @click="previewDoc(doc)">
            <img v-if="showDocImg(doc)" :src="doc.url" class="doc-img" alt="" @error="onDocImgError(doc.key)" />
            <div v-else class="doc-placeholder">{{ doc.icon }}</div>
            <div class="doc-label">{{ doc.label }}</div>
          </div>
        </div>
        <!-- 右侧：审核信息 -->
        <div>
          <div class="detail-section">
            <div class="detail-sec-title">用户信息</div>
            <div class="review-detail-grid">
              <div class="detail-item"><div class="di-label">申请编号</div><div class="di-value">{{ reviewDetail.pnoNo }}</div></div>
              <div class="detail-item"><div class="di-label">用户ID</div><div class="di-value">{{ reviewDetail.customerNo }}</div></div>
              <div class="detail-item"><div class="di-label">姓名</div><div class="di-value">{{ reviewDetail.name }}</div></div>
              <div class="detail-item"><div class="di-label">手机号</div><div class="di-value">{{ (reviewDetail.phonePrefix ? '+' + reviewDetail.phonePrefix + ' ' : '') + (reviewDetail.phoneNumber || '') }}</div></div>
              <div class="detail-item"><div class="di-label">邮箱</div><div class="di-value">{{ reviewDetail.email || '-' }}</div></div>
              <div class="detail-item"><div class="di-label">国家</div><div class="di-value">{{ countryLabel(reviewDetail.countryCode) }}</div></div>
              <div class="detail-item"><div class="di-label">注册方式</div><div class="di-value">{{ regLabel(reviewDetail.regWay) }}</div></div>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">注册信息校验</div>
            <div class="review-detail-grid" style="grid-template-columns:repeat(3,1fr);">
              <div class="detail-item"><div class="di-label">注册IP</div><div class="di-value">{{ reviewDetail.regIp || '-' }}</div></div>
              <div class="detail-item"><div class="di-label">IP归属地</div><div class="di-value">{{ reviewDetail.ipRegion || '-' }}</div></div>
              <div class="detail-item"><div class="di-label">设备指纹</div><div class="di-value">{{ reviewDetail.deviceFingerprint || '-' }}</div></div>
            </div>
          </div>
          <div class="detail-section" style="margin-top:16px;">
            <div class="detail-sec-title">审核结论</div>
            <div style="margin-bottom:12px;">
              <el-radio-group v-model="reviewResult">
                <el-radio label="pass">通过</el-radio>
                <el-radio label="reject">拒绝</el-radio>
              </el-radio-group>
            </div>
            <div style="margin-bottom:12px;">
              <div style="font-size:12px;color:#909399;margin-bottom:4px;">拒绝原因</div>
              <el-input v-model="reviewReason" :disabled="reviewResult!=='reject'" placeholder="请输入拒绝原因" type="textarea" :rows="2"></el-input>
            </div>
            <div>
              <div style="font-size:12px;color:#909399;margin-bottom:4px;">审核备注</div>
              <el-input type="textarea" v-model="reviewNote" :rows="3" placeholder="请输入审核备注（选填）"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="reviewVisible=false">取消</el-button>
        <el-button v-auth="'business:accountApply:review'" type="primary" @click="submitReview">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { accountApplyList, accountApplyStats, accountApplyDetail, accountApplyReview, accountApplyReviewBatch, accountApplyExport } from '@/api/accountApply'
import { countryList } from '@/api/regConfig'
import { customerGroupList } from '@/api/customerGroup'
import { tagListAll } from '@/api/tagManagement'

export default {
  name: 'AccountApplyList',
  data() {
    return {
      tableData: [], loading: false, pageNum: 1, pageSize: 10, total: 0, activeTab: 'all',
      search: { pnoNo: '', customerNo: '', name: '', phone: '', email: '', referrer: '', countryCode: '', regWay: null, groupId: null, tagId: null, createDate: null },
      stats: {}, countries: [], groupOptions: [], tagOptions: [],
      detailVisible: false, detail: null,
      reviewVisible: false, reviewDetail: null, reviewResult: 'pass', reviewReason: '', reviewNote: '',
      // 证件图加载失败标记（key=front/back/handheld）：CDN 不可达或链接失效时回退占位图标
      docImgError: {},
      selection: [],
      ocrRows: [{ field: '姓名', ocr: '-', user: '', match: false }, { field: '号码', ocr: '-', user: '', match: false }]
    }
  },
  computed: {
    // 证件识别比对：详情弹窗用 detail，审核弹窗用 reviewDetail。
    // 原先拆成两个同名 computed 块，后一个会把前一个整个覆盖掉（ocrData 一直是 undefined，详情里的比对表渲染不出来），这里合并
    ocrData() { return this.buildOcrRows(this.detail) },
    reviewOcrData() { return this.buildOcrRows(this.reviewDetail) },
    // 审核弹窗左侧申请资料三张证件图
    kycDocs() {
      const d = this.reviewDetail || {}
      return [
        { key: 'front', label: '身份证正面', icon: '🪪', url: d.frontImageUrl },
        { key: 'back', label: '身份证反面', icon: '🪪', url: d.backImageUrl },
        { key: 'handheld', label: '手持证件照', icon: '👤', url: d.handheldImageUrl }
      ]
    },
    reviewFields() {
      if (!this.reviewDetail) return []
      return [
        { label: '申请编号', value: this.reviewDetail.pnoNo },
        { label: '用户ID', value: this.reviewDetail.customerNo },
        { label: '姓名', value: this.reviewDetail.name },
        { label: '手机号', value: (this.reviewDetail.phonePrefix ? '+' + this.reviewDetail.phonePrefix + ' ' : '') + (this.reviewDetail.phoneNumber || '') },
        { label: '邮箱', value: this.reviewDetail.email || '-' },
        { label: '国家', value: this.countryLabel(this.reviewDetail.countryCode) },
        { label: '注册方式', value: this.regLabel(this.reviewDetail.regWay) },
        { label: '注册IP', value: this.reviewDetail.regIp || '-' },
        { label: '证件号码', value: this.reviewDetail.docNumber || '---' },
        { label: '推荐人', value: this.reviewDetail.referrer || '-' }
      ]
    }
  },
  mounted() { this.fetchList(); this.fetchStats(); this.fetchCountries(); this.fetchGroups(); this.fetchTags() },
  methods: {
    fetchList() {
      this.loading = true
      const params = { pageNum: this.pageNum, pageSize: this.pageSize, ...this.search }
      const tabMap = { pending: 1, passed: 2, rejected: 3, failed: 4 }
      if (this.activeTab !== 'all') params.approvedStatus = tabMap[this.activeTab]
      accountApplyList(params).then(res => {
        if (res.code === 0) { this.tableData = res.result.list || []; this.total = res.result.total || 0 }
      }).finally(() => { this.loading = false })
    },
    fetchStats() { accountApplyStats().then(res => { if (res.code === 0) this.stats = res.result || {} }) },
    fetchCountries() { countryList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.countries = res.result.list || [] }) },
    fetchGroups() { customerGroupList({ pageNum: 1, pageSize: 500 }).then(res => { if (res.code === 0) this.groupOptions = res.result.list || [] }) },
    fetchTags() { tagListAll().then(res => { if (res.code === 0) this.tagOptions = res.result || [] }) },
    resetSearch() { this.search = { pnoNo:'',customerNo:'',name:'',phone:'',email:'',referrer:'',countryCode:'',regWay:null,groupId:null,tagId:null,createDate:null }; this.fetchList() },
    handleExport() {
      const rows = this.$refs.applyTable.selection
      const tabMap = { pending: 1, passed: 2, rejected: 3, failed: 4 }
      const params = { ...this.search }
      if (rows.length > 0) {
        params.ids = rows.map(r => r.id).join(',')
      } else if (this.activeTab !== 'all') {
        params.approvedStatus = tabMap[this.activeTab]
      }
      accountApplyExport(params).then(res => {
        const blob = res instanceof Blob ? res : new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = '开户申请.xlsx'; a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    regLabel(v) { const m={1:'H5',2:'Android',3:'IOS',4:'PC'}; return m[v]||'-' },
    statusLabel(v) { const m={1:'待审核',2:'已通过',3:'已拒绝',4:'申请失败'}; return m[v]||'-' },
    statusType(v) { const m={1:'warning',2:'success',3:'danger',4:'info'}; return m[v]||'info' },
    countryLabel(code) { const c=this.countries.find(x=>x.countryCode===code); return c?c.countryCname||c.countryName:code||'-' },
    groupLabel(id) { const g=this.groupOptions.find(x=>x.id===id); return g?g.groupName:id||'-' },
    docTypeLabel(v) { const m={1:'身份证',2:'护照',3:'驾驶证',4:'居留许可'}; return m[v]||'-' },
    buildOcrRow(d, idx) {
      if (!d) return { field: '', ocr: '-', user: '-', match: false }
      if (typeof idx === 'undefined') idx = 0
      const rows = this.buildOcrRows(d)
      return (rows && rows.length > idx) ? rows[idx] : { field: '', ocr: '-', user: '-', match: false }
    },
    buildOcrRows(d) {
      if (!d) return []
      return [
        { field: '姓名', ocr: '-', user: d.name || '-', match: false },
        { field: '号码', ocr: '-', user: d.docNumber || '---', match: false }
      ]
    },
    handleSelectionChange(v) { this.selection = v },
    openDetail(row) { accountApplyDetail(row.id).then(res => { if (res.code === 0) { this.detail = res.result; this.detailVisible = true } }) },
    openReview(row) {
      this.reviewResult = 'pass'; this.reviewReason = ''; this.reviewNote = ''
      // 换一条申请要清掉上一条的图片加载失败标记，否则同一位置会一直显示占位图标
      this.docImgError = {}
      accountApplyDetail(row.id).then(res => { if (res.code === 0) { this.reviewDetail = res.result; this.reviewVisible = true } })
    },
    submitReview() {
      if (this.reviewResult === 'reject' && !this.reviewReason) return this.$message.warning('请输入拒绝原因')
      accountApplyReview({
        id: this.reviewDetail.id,
        result: this.reviewResult,
        reason: this.reviewReason,
        note: this.reviewNote
      }).then(res => {
        if (res.code === 0) {
          this.$message.success(this.reviewResult === 'pass' ? '审核通过' : '已拒绝')
          this.reviewVisible = false
          this.fetchList()
          this.fetchStats()
        }
      })
    },
    // 证件图是否可展示：有 URL 且未标记加载失败
    showDocImg(doc) { return !!doc.url && !this.docImgError[doc.key] },
    onDocImgError(key) { this.$set(this.docImgError, key, true) },
    previewDoc(doc) {
      if (!this.showDocImg(doc)) return this.$message.info('暂未上传' + doc.label)
      window.open(doc.url)
    },
    // 批量审核：只对「待审核」的记录生效。已通过/已拒绝/申请失败的记录再审一次，
    // 后台会直接拒绝（已通过的再审会重复开 MT5 账户），所以这里先过滤掉并告知用户
    batchReview(result) {
      const selected = this.$refs.applyTable.selection || []
      const rows = selected.filter(r => r.approvedStatus === 1)
      const skipped = selected.length - rows.length
      if (rows.length === 0) {
        return this.$message.warning(skipped > 0 ? '选中的记录都不是「待审核」，无法审核' : '请选择申请记录')
      }
      const ids = rows.map(r => r.id).join(',')
      const skipTip = skipped > 0 ? `（另有 ${skipped} 条非待审核，已跳过）` : ''
      const ask = result === 'pass'
        ? this.$confirm(`确认通过选中的 ${rows.length} 条申请?${skipTip}`, '批量审批', { type: 'warning' })
        : this.$prompt(`确认拒绝选中的 ${rows.length} 条申请?${skipTip}`, '批量拒绝', {
          inputPlaceholder: '请输入拒绝原因',
          inputValidator: v => (v && v.trim() ? true : '拒绝原因不能为空')
        })
      ask.then(input => {
        const reason = input && input.value ? input.value : ''
        accountApplyReviewBatch({ ids, result, reason, note: '' }).then(res => {
          if (res.code !== 0) return
          const data = res.result || {}
          const fail = data.failCount || 0
          if (data.successCount > 0) {
            this.$message.success(`已${result === 'pass' ? '通过' : '拒绝'} ${data.successCount} 条`)
          }
          if (fail > 0) {
            this.$alert((data.failures || []).map(v => this.escapeHtml(v)).join('<br>'), `以下 ${fail} 条审核失败`, {
              type: 'error',
              dangerouslyUseHTMLString: true
            })
          }
          this.$refs.applyTable.clearSelection()
          this.fetchList()
          this.fetchStats()
        })
      }).catch(() => {})
    },
    batchApprove() { this.batchReview('pass') },
    batchReject() { this.batchReview('reject') },
    // 风险标签列：和 clientAccount 的客户标签列共用同一套胶囊渲染
    tagPillStyle(c) {
      return { background: this.colorAlpha(c, 0.125), color: c, border: '1px solid ' + this.colorAlpha(c, 0.25) }
    },
    /** 解析风险标签 JSON，返回 [{n: 名称, c: 颜色}]；空值/脏数据返回空数组 */
    riskTags(row) {
      const raw = row && row.riskTagsJson
      if (!raw) return []
      try {
        const arr = typeof raw === 'string' ? JSON.parse(raw) : raw
        return Array.isArray(arr) ? arr.filter(t => t && t.n) : []
      } catch (e) { return [] }
    },
    // 标签颜色后端存的是十六进制或 rgba() 两种格式，统一转成带透明度的 rgba
    colorAlpha(c, alpha) {
      const color = String(c == null ? '' : c).trim()
      let m = /^#([0-9a-f]{3})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h[0]+h[0],16)}, ${parseInt(h[1]+h[1],16)}, ${parseInt(h[2]+h[2],16)}, ${alpha})` }
      m = /^#([0-9a-f]{6})$/i.exec(color)
      if (m) { const h = m[1]; return `rgba(${parseInt(h.slice(0,2),16)}, ${parseInt(h.slice(2,4),16)}, ${parseInt(h.slice(4,6),16)}, ${alpha})` }
      m = /^rgba?\(([^)]+)\)$/i.exec(color)
      if (m) { const p = m[1].split(','); return `rgba(${p[0]}, ${p[1]}, ${p[2]}, ${alpha})` }
      return `rgba(90, 101, 120, ${alpha})`
    },
    escapeHtml(v) {
      return String(v).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
    }
  }
}
</script>

<style scoped>
.page-container { padding: 16px; }
.stats-row { display: flex; gap: 12px; margin-bottom: 16px; }
.stat-card { background: #fff; border-radius: 4px; padding: 16px 20px; flex: 1; text-align: center; }
.stat-label{font-size:12px;color:#909399;margin-bottom:4px;}
.stat-value{font-size:24px;font-weight:600;color:#303133;}
.filter-bar{background:#fff;padding:12px;border-radius:4px;margin-bottom:12px;}
.table-wrapper{background:#fff;border-radius:4px;padding:16px;}
.table-header{margin-bottom:8px;}
.table-title{font-size:15px;font-weight:600;}
.detail-section{margin-bottom:12px;}
.detail-sec-title{font-size:14px;font-weight:600;color:#303133;margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #ebeef5;}
.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 24px;}
.info-item{display:flex;flex-direction:column;gap:2px;}
.info-label{font-size:12px;color:#909399;}
.info-val{font-size:13px;color:#303133;}
.risk-cards{display:grid;grid-template-columns:repeat(2,1fr);gap:12px;}
.risk-card{padding:12px;border:1px solid #ebeef5;border-radius:8px;display:flex;align-items:center;gap:10px;}
.risk-icon{font-size:20px;}
.risk-label{font-size:12px;color:#909399;}
.risk-val{font-size:13px;font-weight:500;}
.kyc-layout{display:grid;grid-template-columns:280px 1fr;gap:24px;}
.kyc-docs{display:flex;flex-direction:column;gap:12px;}
.kyc-doc-card{background:#f5f7fa;border:1px solid #ebeef5;border-radius:8px;padding:20px;text-align:center;cursor:pointer;transition:all 0.2s;}
.kyc-doc-card:hover{border-color:var(--brand-primary);background:var(--brand-primary-light);}
.doc-placeholder{font-size:40px;margin-bottom:8px;}
.doc-label{font-size:12px;color:#909399;}
/* 有图时收紧内边距，缩略图铺满卡片宽度 */
.kyc-doc-card.is-filled{padding:8px;}
.doc-img{display:block;width:100%;height:120px;object-fit:cover;border-radius:6px;background:#fff;}
.kyc-doc-card.is-filled .doc-label{margin-top:6px;}
.review-detail-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px 24px;}
.detail-item{font-family:monospace;}
.detail-item .di-label{font-size:11px;color:#909399;margin-bottom:2px;}
.detail-item .di-value{font-size:13px;color:#303133;}
/* 风险标签列（和 clientAccount 的客户标签列一致）：彩色胶囊 + 只展示第一个 + 「…」+ 悬浮 tooltip 看全部 */
.ctag{display:inline-flex;align-items:center;gap:4px;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:500;margin-right:4px;white-space:nowrap;}
.ctag-dot{width:6px;height:6px;border-radius:50%;flex-shrink:0;}
.ctag-cell{display:inline-flex;align-items:center;max-width:100%;}
.ctag-cell .ctag{margin-right:0;}
.ctag-more{margin-left:2px;color:#9ca3af;font-size:12px;font-weight:500;flex-shrink:0;}
.ctag-tip{display:flex;flex-wrap:wrap;max-width:260px;row-gap:6px;}
</style>
